var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"text-white",attrs:{"type":_vm.alertType}},[_vm._v(" "+_vm._s(_vm.actual)+" mins "),_c('span',{staticStyle:{"font-size":"smaller","float":"right"}},[_vm._v("("+_vm._s(_vm.min)+" - "+_vm._s(_vm.max)+")")])])}
var staticRenderFns = []

export { render, staticRenderFns }